import { useEffect, useState } from "react";
import { FormatDateShort } from "utils/dateUtils";
import { incidentsService } from "Dashboard/scenes/Incidents/services/incidents.service";
import { IIncident } from "Dashboard/scenes/Incidents/domain/IIncident";
import { IIncidentSearch } from "Dashboard/scenes/Incidents/domain/IIncidentSearch";
import { IEmployee } from "Dashboard/scenes/HumanResources/domain/IEmployee";
import Loader from "components/Loader/Loader";
import { useIncidentTypeOptions } from "Dashboard/scenes/Incidents/hooks/IncidentTypeOptions";
import { FormatNumberOrNull, FormatNumberWithUnitOrNull } from "utils/numberUtils";

interface IProps {
  employee: IEmployee;
}

const Incidents = ({ employee }: IProps) => {
  const [month] = useState(new Date().getMonth());
  const [incidents, setIncidents] = useState<IIncident[]>([]);
  const [totalCount, setTotalCount] = useState<number>();
  const [totalValue, setTotalValue] = useState<number>();
  const [incidentsLoading, setIncidentsLoading] = useState(false);
  const { incidentTypeOptions, setIncidentTypeOptions } =
    useIncidentTypeOptions();

  useEffect(() => {
    const getIncidents = async (data: IIncidentSearch) => {
      try {
        setIncidentsLoading(true);
        let result = await incidentsService.getAllIncidentsInPeriodForEmployee({
          employeeId: data.employeeId,
          from: data.from,
          to: data.to,
        });
        setIncidents(result.incidents);
        setTotalCount(result.incidents.length);
        setTotalValue(result.totalAmount);
      } catch (err) {
        console.log(err);
      } finally {
        setIncidentsLoading(false);
      }
    };

    if (employee) {
      getIncidents({ employeeId: employee.employeeId });
    }
  }, [month, employee?.employeeId]);
  return (
    <div className="incidents-info loading-container">
      {incidentsLoading && <Loader />}
      <div className="selectable-headline">
        <span>Incidenti</span>
        {/* <MonthSelect
          defaultValue={month + 1}
          name="months"
          onChange={(e: ChangeEvent<HTMLSelectElement>) => {
            setMonth(Number(e.target.value) - 1);
          }}
        /> */}
      </div>
      <div className="additional-container">
        {incidents.length > 0 &&
          incidents.map((incident, index) => (
            <div className="" key={index}>
              <div className="hr-incidents-card">
                <span className="data-cell">{incident.amount}</span>
                <span className="date-cell">
                  {FormatDateShort(incident.date)}
                </span>
              </div>
              <span className="hr-ic-note">
                {
                  incidentTypeOptions.find(
                    (option) => option.value === incident.incidentTypeId
                  )?.label
                }
              </span>
              <span className="hr-ic-note gray">{incident.description}</span>
            </div>
          ))}
      </div>
      <div className="additional-sum">
        Ukupno: <span className="count-cell">{FormatNumberOrNull(totalCount)}</span>
        <span className="value-cell">{FormatNumberWithUnitOrNull(totalValue, 'rsd')}</span>
      </div>
    </div>
  );
};

export default Incidents;
